import React, { PropsWithChildren } from 'react';
import { useQuery } from 'react-query';
import { getCmsData } from '../../services/cmsData';
import { Loader } from '../Loader';
import { ContentManagerContextProvider } from '../../state/content-manager';
import { QUERY_KEYS } from 'utils/constants';

export const ContentManager: React.FC<PropsWithChildren> = ({ children }) => {
  const cmsDataQuery = useQuery(QUERY_KEYS.CMS_DATA, () => getCmsData(), {
    refetchOnWindowFocus: false,
  });

  return (
    <Loader query={cmsDataQuery}>
      {!!cmsDataQuery.data && (
        <ContentManagerContextProvider value={cmsDataQuery.data}>
          {children}
        </ContentManagerContextProvider>
      )}
    </Loader>
  );
};
